import { render } from "./MinistryManagerList.vue?vue&type=template&id=6a565940&scoped=true"
import script from "./MinistryManagerList.vue?vue&type=script&lang=js"
export * from "./MinistryManagerList.vue?vue&type=script&lang=js"

import "./MinistryManagerList.vue?vue&type=style&index=0&id=6a565940&scoped=true&lang=css"
import "./MinistryManagerList.vue?vue&type=style&index=1&id=6a565940&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a565940"]])

export default __exports__